module.exports = __webpack_public_path__ + "img/main-sky-background.da00e3da.jpg";